import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=419dc13d&scoped=true&"
import script from "./sidebar.vue?vue&type=script&lang=js&"
export * from "./sidebar.vue?vue&type=script&lang=js&"
import style0 from "./sidebar.scss?vue&type=style&index=0&id=419dc13d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419dc13d",
  null
  
)

export default component.exports